import { EmptyStateWithIllustration } from '@/components/display/EmptyStateWithIllustration/EmptyStateWithIllustration';
import { Button } from '@/components/form/baseInputs/Button';
import { useFormFieldsDisabled } from '@/components/form/context/formFieldsDisabled.context';
import { PlusIcon } from '@/components/icons/PlusIcon';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';

const HEADING = 'No insurance policies';
const DESCRIPTION =
  'There are no insurance policies associated with this entity. Add a policy to get started.';

interface InsurancePolicyEmptyStateProps {
  onAdd: () => void;
}

export function InsurancePolicyEmptyState({
  onAdd,
}: InsurancePolicyEmptyStateProps) {
  const canEdit = useCanEditHouseholdData();
  const { disabled } = useFormFieldsDisabled();

  return (
    <EmptyStateWithIllustration
      title={HEADING}
      description={DESCRIPTION}
      action={
        canEdit ? (
          <Button
            variant="secondary"
            size="sm"
            startIcon={PlusIcon}
            disabled={disabled}
            onClick={onAdd}
          >
            Add insurance policy
          </Button>
        ) : undefined
      }
    />
  );
}
